<template>
  <header
    class="w-[328px] lg:w-[760px] relative top-[67px] lg:top-[47px] bg-white shadow-md rounded-[15px] left-[50%] translate-x-[-50%] min-h-[140px] max-h-[160px] lg:min-h-[140px] lg:max-h-[220px] z-20"
    :style="{ height: headerHeight }"
  >
    <div
      class="w-[92px] lg:w-[111px] h-[92px] lg:h-[111px] top-[-54px] lg:top-[9px] lg:right-[50px] bg-white absolute rounded-full shadow-md left-[50%] translate-x-[-50%] lg:translate-x-[320px] flex justify-center items-center"
    >
      <img
        v-if="logoPath"
        :src="logoPath"
        alt="logo"
        class="rounded-full w-full h-full flex justify-center items-center"
      />
      <div
        v-else
        class="rounded-full w-full h-full flex justify-center items-center"
      ></div>
    </div>
    <div
      class="lg:pl-[10px] top-[38px] lg:left-[18px] lg:top-[10px] pt-4 relative text-center font-normal balanced lg:w-[650px]"
    >
      <slot name="title">
        <label
          class="block text-main text-[25px]/[25px] lg:text-[40px]/[40px] cursor-pointer"
          ref="titleRef"
          @click="emits('titleClick')"
          :tabindex="1"
          :dir="dir"
        >
          {{ title }}
        </label>
      </slot>
      <slot name="sub-title">
        <label
          class="text-center block lg:inline text-[18px] lg:text-[29px]"
          :tabindex="2"
        >
          {{ subTitle }}
        </label>
      </slot>
    </div>
  </header>
</template>

<script setup lang="ts">
defineProps<{
  logoPath?: string;
  title?: string;
  subTitle?: string;
  bgColor?: string;
  dir?: string;
}>();
const emits = defineEmits<{ titleClick: [] }>();
const titleRef = ref<any>(null);

const headerHeight = computed(
  () => `${titleRef?.value?.offsetHeight ?? 20 + 80}px`
);
</script>

<style scoped></style>
